<div
  class="table-container mark"
  [ngStyle]="getContainerStyle(reportCustomElemet)"
  (click)="onClick($event)"
  [ngClass]="{
    'dynamic-mark': true
  }"
>
  <div
    style="height: 9mm; padding: 0 5mm; font-weight: bold"
    [style.font-size]="reportCustomElemet.titleFontSize"
    [style.text-align]="reportCustomElemet.titleAlign"
    [style.background-color]="reportCustomElemet.titleBackgroundColor"
  >
    {{ reportCustomElemet.titleText }}
  </div>
  <div class="my-2">
    <span
      >Name:<strong>{{ reportCustomElemet.designElementName }}</strong></span
    >
  </div>

  <div [ngStyle]="getStyles(reportCustomElemet)">
    <img alt="Custom Element" />
  </div>
</div>
